import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { DemoRoutes } from './demo/demo-routing.module';
import { AccessDeniedPageComponent } from './pages/errors/accessdenied/accessdenied-page.component';
import { NotFoundPageComponent } from './pages/errors/notfound/notfound-page.component';
import { AuthGuard } from './services/auth.service';
import { UserSummaryPageComponent } from './pages/user-summary/user-summary-page.component';
import { UserPageComponent } from './pages/user-page/user-page.component';
import { ExploitationSummaryPageComponent } from './pages/exploitation-summary/exploitation-summary-page.component';
import { ExploitationPageComponent } from './pages/exploitation-page/exploitation-page.component';
import { VersionPageComponent } from './pages/version-page/version-page.component';
import { ChartPageComponent } from './pages/chart-page/chart-page.component';
import { MessageSummaryPageComponent } from './pages/message-summary/message-summary-page.component';

@NgModule({
	imports: [
		RouterModule.forRoot(
			[
				{
					path: '',
					component: AppMainComponent,
					canActivateChild: [AuthGuard],
					children: [
						{ path: '', redirectTo: '/accueil', pathMatch: 'full' },
						{
							path: 'accueil',
							component: ExploitationSummaryPageComponent,
						},
						{
							path: 'inventaire/exploitation',
							component: ExploitationSummaryPageComponent,
						},
						{
							path: 'inventaire/exploitation/:id',
							component: ExploitationPageComponent,
						},
						{
							path: 'inventaire/utilisateur',
							component: UserSummaryPageComponent,
						},
						{
							path: 'inventaire/utilisateur/:id',
							component: UserPageComponent,
						},
						{
							path: 'messages',
							component: MessageSummaryPageComponent,
						},
						{
							path: 'version',
							component: VersionPageComponent,
						},
						{
							path: 'statistiques',
							component: ChartPageComponent,
						},
					],
				},
				{ path: 'access', component: AccessDeniedPageComponent },
				{ path: 'notfound', component: NotFoundPageComponent },
				{ path: 'demo', children: DemoRoutes },
				{ path: '**', redirectTo: '/notfound' },
			],
			{ scrollPositionRestoration: 'enabled' },
		),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
